module.exports = __webpack_public_path__ + "static/media/10.f2f84fb5.JPG";